/**
 * Determines if a sphere qualifies as a center based on schema data.
 *
 * @param sphereType - The sphere's schema system name (e.g. 'center_center')
 * @param centerTypes - List of schema system names classified as center types,
 *   typically fetched from GET /schemas/center-types
 */
export function isSphereACenter(sphereType: string, centerTypes: string[]): boolean {
    return centerTypes.includes(sphereType);
}
